
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punestationtomumbaicabservice() {



    const cardData =
    {
        keyword: 'Pune Station to Mumbai Cabs Service',
        heading: 'Meghana Cab : Pune Station to Mumbai Cabs Service',
        headingDescription: 'Meghana Cab offers Pune Station to Mumbai Cabs Service, ensuring a convenient and timely travel option for passengers arriving at Pune Railway Station and heading to Mumbai. Whether you are planning an airport drop, business visit, or leisure trip, our wide fleet—ranging from Hatchbacks and Sedans to SUVs and Innova Crysta—caters to all types of travelers. With professional drivers, punctual service, door-to-door pickup, and transparent pricing, we make your intercity journey smooth and stress-free. Book your Pune Station to Mumbai Cab with Meghana Cab and enjoy reliable, comfortable, and round-the-clock cab services.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

    "services": [
    {
      "name": "Pune Railway Station to Mumbai Taxi",
      "description": "Reliable and comfortable taxi service from Pune Railway Station to Mumbai. Our professional drivers ensure timely pickups and drop-offs, making your railway station transfer smooth and hassle-free."
    },
    {
      "name": "One Way Cab Pune Station to Mumbai",
      "description": "Book a one-way cab from Pune Railway Station to Mumbai for quick and direct travel. Ideal for passengers arriving at the station who want seamless transfer to Mumbai without any delays."
    },
    {
      "name": "Round Trip Cab from Pune Station to Mumbai",
      "description": "Our round trip cab service provides flexible travel options with pick-up and drop-off between Pune Railway Station and Mumbai. Perfect for business travelers and tourists planning return journeys."
    },
    {
      "name": "Station Pickup Cab Pune to Mumbai",
      "description": "Enjoy hassle-free pickup from Pune Railway Station with our dedicated cab service to Mumbai. Drivers track your train status to ensure timely arrival and comfortable onward travel."
    },
    {
      "name": "Online Taxi Booking Pune Station to Mumbai",
      "description": "Conveniently book your taxi online from Pune Railway Station to Mumbai. Get instant confirmations, secure payments, and easy cancellation policies for a stress-free booking experience."
    },
    {
      "name": "Budget Cabs Pune Station to Mumbai",
      "description": "Affordable taxi options from Pune Railway Station to Mumbai without compromising comfort or safety. Ideal for budget-conscious travelers looking for economical yet reliable rides."
    },
    {
      "name": "Sedan Hire Pune Station to Mumbai",
      "description": "Choose our sedan hire service for a comfortable and stylish journey from Pune Railway Station to Mumbai. Suitable for solo travelers, couples, and business professionals."
    },
    {
      "name": "SUV Cab Pune Station to Mumbai",
      "description": "Spacious and powerful SUVs available for group travel or families from Pune Railway Station to Mumbai. Enjoy extra luggage space and a smooth ride on highway routes."
    },
    {
      "name": "Chauffeur Service Pune Station to Mumbai",
      "description": "Experience professional chauffeur-driven taxi service from Pune Railway Station to Mumbai. Our courteous drivers provide personalized service, ensuring your comfort and safety throughout the journey."
    },
    {
      "name": "Family Cab Pune Station to Mumbai",
      "description": "Family-friendly cabs from Pune Railway Station to Mumbai, equipped with ample space and safety features. Perfect for families traveling together with kids and luggage."
    },
    {
      "name": "Quick Booking Pune Station to Mumbai Taxi",
      "description": "Need a cab in a hurry? Our quick booking service guarantees swift taxi allocation from Pune Railway Station to Mumbai, minimizing your wait time."
    },
    {
      "name": "Private Cab Pune Railway Station to Mumbai",
      "description": "Enjoy privacy and flexibility with our private cab services from Pune Railway Station to Mumbai. Tailor your trip according to your schedule without sharing rides."
    },
    {
      "name": "Corporate Taxi Pune Station to Mumbai",
      "description": "Efficient and professional corporate taxi services from Pune Railway Station to Mumbai, catering to business travelers with punctuality and premium comfort."
    },
    {
      "name": "Reliable Station to Mumbai Taxi",
      "description": "Depend on our reliable taxi service for timely and safe travel from Pune Railway Station to Mumbai. We prioritize customer satisfaction and vehicle upkeep for consistent service quality."
    },
    {
      "name": "24-Hour Cab Pune Station to Mumbai",
      "description": "Our 24/7 taxi service ensures you can travel from Pune Railway Station to Mumbai at any time, day or night. Perfect for late-night arrivals or early morning departures."
    }
  ],
  "tableData": [
    ["Pune Railway Station to Mumbai Taxi", "One Way Cab Pune Station to Mumbai"],
    ["Round Trip Cab from Pune Station to Mumbai", "Station Pickup Cab Pune to Mumbai"],
    ["Online Taxi Booking Pune Station to Mumbai", "Budget Cabs Pune Station to Mumbai"],
    ["Sedan Hire Pune Station to Mumbai", "SUV Cab Pune Station to Mumbai"],
    ["Chauffeur Service Pune Station to Mumbai", "Family Cab Pune Station to Mumbai"],
    ["Quick Booking Pune Station to Mumbai Taxi", "Private Cab Pune Railway Station to Mumbai"],
    ["Corporate Taxi Pune Station to Mumbai", "Reliable Station to Mumbai Taxi"],
    ["24-Hour Cab Pune Station to Mumbai", ""]
  ],




"whychoose": [
    {
        "WhyChooseheading": "Convenient Pune Station to Mumbai Cab Service for Stress-Free Travel",
        "WhyChoosedescription": "Our cab service from Pune Station to Mumbai offers hassle-free transportation with prompt pickups and timely drop-offs. Whether you’re arriving by train or planning to travel from the station, we ensure a seamless transition to your Mumbai destination."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in air-conditioned, spacious cabs that are regularly serviced and sanitized. Our fleet includes sedans, SUVs, and premium cars to cater to your specific comfort and luggage needs."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are trained, courteous, and well-versed with routes between Pune Station and Mumbai. They ensure a safe, smooth ride and assist with luggage, providing you a comfortable and stress-free journey."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "We offer clear and upfront pricing that includes fuel, tolls, taxes, and driver allowances. Our transparent pricing policy ensures no hidden charges, helping you plan your travel budget effectively."
    },
    {
        "WhyChooseheading": "Flexible Booking with Customized Travel Options",
        "WhyChoosedescription": "Choose from one-way rides, round trips, or hourly rentals based on your schedule. Customize your pickup and drop-off locations within Pune Station and Mumbai to match your travel plans perfectly."
    },
    {
        "WhyChooseheading": "Door-to-Door Pickup and Drop-off for Maximum Convenience",
        "WhyChoosedescription": "Our service includes direct pickups from Pune Station and drops you at your preferred destination in Mumbai. This door-to-door service eliminates the need for additional transfers, making your travel hassle-free."
    },
    {
        "WhyChooseheading": "Ideal for Business Travel, Airport Transfers, and Leisure Trips",
        "WhyChoosedescription": "Whether you’re heading to Mumbai for business meetings, catching a flight, or exploring the city for leisure, our cab service offers the perfect combination of comfort, reliability, and professionalism."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Online Booking",
        "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with bookings, cancellations, or special requests. Book your Pune Station to Mumbai cab anytime through our user-friendly online platform."
    }
]























    }

const faqData = [
    {
        question: "How can I book a cab from Pune Station to Mumbai?",
        answer: "You can book your cab by calling Meghana Cab at +91 9075462128 or by visiting our website for easy online booking."
    },
    {
        question: "Is the pickup available directly from Pune Railway Station?",
        answer: "Yes, we offer direct pickups from Pune Station. Our driver will coordinate with you for a hassle-free pickup."
    },
    {
        question: "What is the travel time from Pune Station to Mumbai by cab?",
        answer: "The journey usually takes 3 to 4 hours, depending on traffic and road conditions."
    },
    {
        question: "Do you offer both one way and round trip services from Pune Station?",
        answer: "Yes, you can choose between one way and round trip options based on your travel plans."
    },
    {
        question: "What types of cabs are available from Pune Station to Mumbai?",
        answer: "We provide hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for all group sizes."
    },
    {
        question: "Is your Pune Station to Mumbai cab service available 24/7?",
        answer: "Yes, we operate 24/7 to ensure availability at any time of the day or night."
    },
    {
        question: "What is included in the fare?",
        answer: "The fare includes fuel, tolls, and driver charges. Any additional stops or waiting time may be billed extra."
    },
    {
        question: "Can I request a stop for food or rest on the way?",
        answer: "Yes, you can request planned stops during the journey. Please inform us while booking or inform the driver."
    },
    {
        question: "Is online payment available for booking?",
        answer: "Yes, we accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "Are your drivers trained and punctual?",
        answer: "Absolutely. Our drivers are well-trained, background-verified, and always aim for timely pickups and safe journeys."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Kunal More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked a cab from Pune Station to Mumbai after arriving by train. The driver was already waiting — very smooth experience!”',
    },
    {
        name: 'Ms. Swati Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service from Pune Station to Mumbai. Clean car, polite driver, and on-time pickup. Will book again.”',
    },
];































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Station to Mumbai Cabs Service",
  "image": "https://www.meghanacabs.com/assets/images/pune-station-to-mumbai-cab.jpg",
  "description": "Book reliable cab service from Pune Railway Station to Mumbai with Meghana Cabs. Options include budget, sedan, SUV, and chauffeur-driven cabs for one-way and round trips. Family and corporate travel available. 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-station-to-mumbai-cabs-service"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune Station to Mumbai Cabs Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book reliable cab service from Pune Railway Station to Mumbai with Meghana Cabs. Budget, sedan, SUV, and chauffeur-driven cabs available for one-way and round trips. Family and corporate travel options. 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune Railway Station to Mumbai Taxi, One Way Cab Pune Station to Mumbai, Round Trip Cab from Pune Station to Mumbai, Station Pickup Cab Pune to Mumbai, Online Taxi Booking Pune Station to Mumbai, Budget Cabs Pune Station to Mumbai, Sedan Hire Pune Station to Mumbai, SUV Cab Pune Station to Mumbai, Chauffeur Service Pune Station to Mumbai, Family Cab Pune Station to Mumbai, Quick Booking Pune Station to Mumbai Taxi, Private Cab Pune Railway Station to Mumbai, Corporate Taxi Pune Station to Mumbai, Reliable Station to Mumbai Taxi, 24-Hour Cab Pune Station to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/59.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punestationtomumbaicabservice;